var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "600px", "max-width": "95vw", persistent: "" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "dialog-card" },
        [
          _c(
            "v-card-title",
            { staticClass: "headline primary white--text" },
            [
              _c("v-icon", { attrs: { left: "", color: "white" } }, [
                _vm._v("send")
              ]),
              _vm._v(" \n      Re-enviar Permiso\n    ")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.enviarPermiso.apply(null, arguments)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                { staticClass: "pt-4" },
                [
                  _c(
                    "v-alert",
                    {
                      staticClass: "mb-4",
                      attrs: { type: "warning", dense: "" }
                    },
                    [
                      _c("strong", [
                        _vm._v("¿Está seguro de re-enviar el permiso?")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-1" }, [
                        _vm._v(
                          "Nota: Ya no podrá realizar cambios después de enviar"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    {
                      staticClass: "select-container",
                      attrs: { row: "", wrap: "" }
                    },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c("v-select", {
                            staticClass: "text-field-reducido-border",
                            attrs: {
                              items: _vm.lista_funcionarios,
                              "item-value": "id_persona",
                              "item-text": _vm.formatearFuncionario,
                              name: "id_funcionario",
                              label: "Seleccione funcionario a enviar *",
                              autofocus: "",
                              required: "",
                              outlined: "",
                              dense: "",
                              rules: [
                                function(v) {
                                  return !!v || "El funcionario es requerido"
                                }
                              ],
                              "return-object": "",
                              loading: _vm.loading,
                              "prepend-icon": "person",
                              "menu-props": { maxHeight: 300, offsetY: true }
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "selection",
                                fn: function(ref) {
                                  var item = ref.item
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "text-truncate" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.formatearFuncionario(item))
                                        )
                                      ]
                                    )
                                  ]
                                }
                              },
                              {
                                key: "item",
                                fn: function(ref) {
                                  var item = ref.item
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "select-item-content" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "list-item-title" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatearFuncionario(item)
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        item.unidad
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "list-item-subtitle"
                                              },
                                              [_vm._v(_vm._s(item.unidad))]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.funcionarioSeleccionado,
                              callback: function($$v) {
                                _vm.funcionarioSeleccionado = $$v
                              },
                              expression: "funcionarioSeleccionado"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.permiso
                    ? _c(
                        "v-expansion-panels",
                        { staticClass: "mt-2", attrs: { flat: "" } },
                        [
                          _c(
                            "v-expansion-panel",
                            [
                              _c("v-expansion-panel-header", {
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var open = ref.open
                                        return [
                                          _c(
                                            "v-row",
                                            { attrs: { "no-gutters": "" } },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "4" } },
                                                [
                                                  _vm._v(
                                                    "Información del Permiso"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass:
                                                    "text--secondary",
                                                  attrs: { cols: "8" }
                                                },
                                                [
                                                  _c(
                                                    "v-fade-transition",
                                                    {
                                                      attrs: {
                                                        "leave-absolute": ""
                                                      }
                                                    },
                                                    [
                                                      open
                                                        ? _c(
                                                            "span",
                                                            { key: "0" },
                                                            [
                                                              _vm._v(
                                                                "\n                        Click para contraer\n                      "
                                                              )
                                                            ]
                                                          )
                                                        : _c(
                                                            "span",
                                                            { key: "1" },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    _vm.permiso
                                                                      .tipo_permiso
                                                                  ) +
                                                                  " - " +
                                                                  _vm._s(
                                                                    _vm.permiso
                                                                      .numero
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ]
                                                          )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2885836261
                                )
                              }),
                              _vm._v(" "),
                              _c("v-expansion-panel-content", [
                                _c("div", { staticClass: "info-list" }, [
                                  _c("div", { staticClass: "info-item" }, [
                                    _c("strong", [_vm._v("Tipo:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.permiso.tipo_permiso) +
                                        "\n                "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "info-item" }, [
                                    _c("strong", [_vm._v("Número:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.permiso.numero) +
                                        "\n                "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "info-item" }, [
                                    _c("strong", [_vm._v("Fecha:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.permiso.fecha_desde) +
                                        " - " +
                                        _vm._s(_vm.permiso.fecha_retorno) +
                                        "\n                "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "info-item" }, [
                                    _c("strong", [_vm._v("Horas:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.permiso.hora_desde) +
                                        " - " +
                                        _vm._s(_vm.permiso.hora_hasta) +
                                        "\n                "
                                    )
                                  ])
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "pa-4" },
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey darken-1",
                        text: "",
                        disabled: _vm.loading
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.close()
                        }
                      }
                    },
                    [_vm._v(" \n          Cancelar \n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        loading: _vm.loading,
                        disabled: !_vm.valid || !_vm.funcionarioSeleccionado,
                        color: "primary",
                        depressed: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.enviarPermiso()
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [_vm._v("send")]),
                      _vm._v("\n          Re-enviar Permiso\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05a3f897", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05a3f897","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/permiso/dialogs/ReenviarPermiso.vue
// module id = null
// module chunks = 